// src/components/repasses/hooks/handleValidateRepasse.ts

import { RowDataRepasse } from "../types";
import { fieldValidators } from "../utils/excelUtils";

/**
 * Executa a validação e processamento dos dados de repasse usando regras genéricas.
 * * @param data Os dados importados do arquivo (RowDataRepasse[]).
 * @returns Os dados processados com status e mensagem de erro/sucesso.
 */
export const handleValidateRepasse = (data: RowDataRepasse[]): RowDataRepasse[] => {
	return data.map((row) => {
		// Inicializa a mensagem e status
		let mensagem = typeof row.mensagem === "string" ? row.mensagem.trim() : "";
		// Se já era inválido antes (ex: na importação), mantém "inválido", senão assume "validado"
		let status: "importado" | "validado" | "inválido" = row.status === "inválido" ? "inválido" : "validado";

		// Usa um Set para garantir mensagens de erro únicas
		const seenMessages = new Set(mensagem.split(" | ").filter(Boolean));

		// Itera sobre o validador de campos (fieldValidators)
		for (const key in fieldValidators) {
			// Garanta que fieldValidators[key] está definido corretamente com 'aliases' e 'validators'
			const fieldValidation = fieldValidators[key];
			if (!fieldValidation || !fieldValidation.aliases || !fieldValidation.validators) continue;

			const { aliases, validators } = fieldValidation;

			// Tenta encontrar o campo na linha usando um dos aliases
			const foundAlias = aliases.find((alias: string) => row.hasOwnProperty(alias));

			if (!foundAlias) continue; // Pula se o campo não estiver na linha (e não for obrigatório)

			const originalValue = row[foundAlias];

			// Aplica todos os validadores para o campo
			for (const validateFn of validators) {
				const result = validateFn(originalValue);

				// Atualiza todos os aliases do campo com o valor padronizado (limpo/formatado)
				aliases.forEach((alias: string) => {
					// Nota: A lógica de atualização pode precisar de ajustes se 'row' não tiver todos os aliases
					if (row[alias] != null) row[alias] = result.value;
				});

				if (result.status === "invalid" && result.message) {
					status = "inválido";
					if (!seenMessages.has(result.message)) {
						seenMessages.add(result.message);
					}
				}
			}
		}

		// Converte as mensagens únicas de volta para uma string
		const novaMensagem = Array.from(seenMessages).join(" | ");

		return {
			...row,
			status,
			mensagem: novaMensagem || "Dados verificados com sucesso.", // Garante que a mensagem não fique vazia se for válido
		};
	});
};
